import { Component, Input, OnInit } from '@angular/core';
import { Tenant } from '../../../../model/tenant';
import { TenantsService } from '../../../../services/tenants.service';
import { MeasurementType } from '../../../../model/measurement-type';

@Component({
  selector: 'app-tenant-measurement-types',
  templateUrl: './tenant-measurement-types.component.html',
  styleUrls: ['./tenant-measurement-types.component.scss']
})
export class TenantMeasurementTypesComponent implements OnInit {

  @Input()
  public tenant: Tenant;

  public measurementTypes: MeasurementType[];
  public totalMeasurementTypes: number;
  public loadingMeasurementTypes: boolean;

  public rows = 10;
  public first = 0;

  constructor(private tenantsService: TenantsService) {}

  ngOnInit(): void {
    this.loadMeasurementTypes(this.first / this.rows, this.rows);
  }

  private loadMeasurementTypes(offset: number, limit: number): void {
    this.loadingMeasurementTypes = true;
    this.tenantsService.getTenantMeasurementTypes(this.tenant.uuid, offset, limit)
      .subscribe(response => {
        this.measurementTypes = response.measurementTypes.sort((a, b) => a.sensor > b.sensor ? 1 : -1);
        this.totalMeasurementTypes = response.totalElements;
        this.loadingMeasurementTypes = false;
      });
  }

  onPageChange(event): void {
    this.loadMeasurementTypes(event.first / event.rows, event.rows);
  }

}
